<div class="row">
    <div class="col-md-6" *ngIf="!acceptance">
        <div class="quote-heading" [id]="quote.quoteId">
            {{ "quoteTracking.lineItemsQuote" | cxTranslate }}{{quote?.quoteId}}
        </div>
    </div>
    <div class="col-md-10 bottom-gap" *ngIf="acceptance">
       <div class="row">
            <div class="col-md-1">        
            <!-- <mat-checkbox
                class="check-box"
                [(ngModel)]="checked"
                (click)="changeCheck()"
                (change)="setAll($event.checked)"
              >
              </mat-checkbox> -->
              <div class="custom-control custom-checkbox">
                <input id="master" type="checkbox" [disabled]="filteredRecords?.length === 0"
                class="custom-control-input"
                [indeterminate]="client.indeterminated"
                [checked]="client.checked"
                (click)="setAll(client, $event);">
                <label for="master" class="custom-control-label"></label>
            </div>
            </div>
            <div class="col-md-3 titles" 
            *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async)"
            (click)="openAcceptModal(false)">
                <i class="material-icons arrow-icon">shopping_cart</i> {{ "quoteTracking.acceptSelected" | cxTranslate }}
            </div>

            <div class="col-md-5 titles" 
            *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async)"
            (click)="openAcceptModal(true)">
                <i class="material-icons arrow-icon">shopping_cart</i> {{ "quoteTracking.acceptdeliveryGroupSelected" | cxTranslate }}
            </div>

            <div class="col-md-3 titles" 
              *ngIf="(checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)"
              (click)="openRejectPopUp()">
                <i class="material-icons arrow-icon">thumb_down</i> {{ "quoteTracking.rejectSelected" | cxTranslate }}
            </div>
       </div>
    </div>
    <div class="col-md-2">
        <div class="quote-toggle">
            <div (click)="toggleThis()" *ngIf="!showToggle">
                <i class="material-icons arrow-icon">
                keyboard_arrow_down
                </i> 
                {{ "quoteTracking.expand" | cxTranslate }}
            </div>
            <div (click)="toggleThis()" *ngIf="showToggle">
                <i class="material-icons arrow-icon">
                    keyboard_arrow_up
                </i> {{ "quoteTracking.collapse" | cxTranslate }}
            </div>
        </div>
    </div>
</div>
<div *ngIf="quoteDetails$ | async as quoteDetails else loading">
    <ng-container *ngIf="acceptance">
        <div *ngFor="let product of quoteDetails?.quoteLineDetails; let i = index">
            <vs-merge-quote-products 
            *ngIf="product?.quoteStatusCode === CurrentQuoteStatus.OPEN"
            [product]="product"
            [productOpen]="showToggle"
            [index]="i"
            (productChecked)='productCheck($event)'
            [checked]='checked'
            [acceptance]='acceptance'
            ></vs-merge-quote-products>
        </div>
    </ng-container>
    <ng-container *ngIf="!acceptance">
        <div *ngFor="let product of quoteDetails?.quoteLineDetails | statusFilter; let i = index">
            <vs-merge-quote-products 
            [product]="product"
            [productOpen]="showToggle"
            [index]="i"
            (productChecked)='productCheck($event)'
            [checked]='checked'
            [acceptance]='acceptance'
            ></vs-merge-quote-products>
        </div>
    </ng-container>
</div>
<ng-template #loading>
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
</ng-template>
